export const getError = state => state.manageTrusted_users.get('error')
export const getIsSubmitting = state => state.manageTrusted_users.get('isSubmitting')
export const getIsAddingEmail = state => state.manageTrusted_users.get('isAddingEmail')
